module.exports = __webpack_public_path__ + "img/illustration-leave.29dca44a.svg";